<template>
	<div class="container" id="EcnyView">
		<div class="header">
			<div class="nav-bar">
				<div class="nav-left">
					<img src="@/assets/ecny/Pandapass_logo.png" alt="Pandapass" class="logo" />
				</div>
				<div class="nav-right">
					<LanguageSwitch />
				</div>
			</div>
		</div>
		<div class="content">
			<div class="ecny-card">
				<!-- 加载状态 -->
				<div class="card-content loading-content" v-if="checkingWallet">
					<div class="loading-section">
						<van-loading type="spinner" size="24px" color="#EA2E17" />
						<div class="loading-text">{{ $t("ecny.checkingWallet") }}</div>
					</div>
				</div>
				<!-- 未绑定状态 -->
				<div class="card-content" v-else-if="!isCardBound">
					<div class="top-section">
						<div class="sleeping-panda">
							<img src="@/assets/no_record.png" alt="Sleeping Panda" class="panda-image" />
						</div>
						<div class="message">
							{{ $t("ecny.noCardMessage") }}
						</div>
					</div>
					<div class="wallet-info">
						<h3>{{ $t("ecny.walletTitle") }}</h3>
						<p>{{ $t("ecny.walletDescription") }}</p>
					</div>
					<div class="button-section">
						<van-button class="add-button" @click="goToOpen">
							{{ $t("ecny.addNow") }}
						</van-button>
					</div>
				</div>
				<!-- 已绑定状态 -->
				<div class="card-content" v-else>
					<div class="ecny-card-display">
						<div class="card-header">
							<img src="@/assets/ecny/card_icon.png" alt="Card Status" class="card-status-icon" />
							<div class="card-status">{{ $t("recharge.cardStatus") }}</div>
						</div>
						<div class="card-body">
							<div class="balance-section">
								<div class="balance">¥ {{ balance }}</div>
								<div class="card-number">{{ cardNumber }}</div>
								<div class="expiry-date">{{ expiryDate }}</div>
							</div>
							<div class="ecny-logo-section">
								<img src="@/assets/ecny/e_cny.png" alt="Pandapass" class="ecny-logo" />
							</div>
						</div>
					</div>
					<div class="wallet-info">
						<h3>{{ $t("ecny.walletTitle") }}</h3>
						<p>{{ $t("ecny.walletDescription") }}</p>
					</div>
					<div class="action-buttons">
						<van-button class="action-btn recharge-btn" @click="rechargeCard">
							<img src="@/assets/ecny/recharge_icon.png" alt="Recharge" class="recharge-icon" />
							{{ $t("ecny.recharge") }}
						</van-button>
					</div>
				</div>
			</div>
		</div>
		<img src="@/assets/ecny/ecny_info.jpg" class="ecny_info" />

		<!-- 弹窗 -->
		<van-popup v-model="showModal" :overlay="true" :close-on-click-overlay="true" round position="center" class="ecny-modal" get-container="body">
			<div class="modal-content">
				<div class="modal-header">
					<h2 class="modal-title">{{ $t("ecny.activeWallet") }}</h2>
				</div>
				<div class="modal-body">
					<div class="input-group">
						<input type="tel" v-model="cardNumber" :placeholder="$t('ecny.enterCard')" class="card-input" maxlength="16" />
						<div v-if="cardNumber && !isCardValid" class="error-message">
							<van-icon name="warning-o" />
							{{ $t("ecny.errorMessage") }}
						</div>
					</div>
					<button class="confirm-btn" :class="{ active: isCardValid }" @click="submitCard" :disabled="!isCardValid">
						{{ $t("ecny.confirm") }}
					</button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import { getUserInfoSafe, getToken, requireLogin } from "@/utils/auth.js";
export default {
	name: "EcnyView",
	data() {
		return {
			isCardBound: false,
			showModal: false,
			cardNumber: "",
			balance: 0.0,
			expiryDate: "",
			isCardValid: true,
			userInfo: null,
			token: null,
			checkingWallet: false,
		};
	},
	mounted() {
		// 页面加载逻辑
		this.checkLogin();
		this.checkWalletStatus();
	},
	activated() {
		// 验证登录是否失效
		this.checkLogin();
		this.checkWalletStatus();
	},
	watch: {
		cardNumber(newVal) {
			this.validateCardNumber(newVal);
		},
	},
	methods: {
		goToOpen() {
			if (!requireLogin(this)) return;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
			this.cardNumber = "";
			this.isCardValid = false;
		},
		validateCardNumber(cardNumber) {
			// 仅保留数字
			const cleanNumber = (cardNumber || "").replace(/\D/g, "");
			// 16位纯数字卡号
			const cardRegex = /^\d{16}$/;
			this.isCardValid = cardRegex.test(cleanNumber);
		},
		submitCard() {
			if (!requireLogin(this)) return;
			if (!this.isCardValid) {
				this.$toast(this.$t("ecny.errorMessage"));
				return;
			}
			const userId = this.userInfo.id;
			const cleanNumber = (this.cardNumber || "").replace(/\D/g, "");
			this.$api
				.postData("/ecny/bind_ecny_wallet", { user_id: userId, card_number: cleanNumber })
				.then((res) => {
					if (res.code === 200) {
						// 后端已脱敏，前端直接使用
						this.cardNumber = res.data.card_number;
						this.balance = res.data.balance;
						this.expiryDate = res.data.created_at.split("-")[1] + "/" + res.data.created_at.split("-")[2];
						this.$toast(this.$t("api.ecnyBindSuccess"));
						this.isCardBound = true;
						this.closeModal();
					} else {
						this.$toast(res.msg ? this.$t(res.msg) : this.$t("api.ecnyBindFailed"));
					}
				})
				.catch(() => {
					this.$toast(this.$t("api.ecnyBindFailed"));
				});
		},
		checkLogin() {
			this.userInfo = getUserInfoSafe();
			this.token = getToken();
		},
		rechargeCard() {
			if (!requireLogin(this)) return;
			// 跳转页面
			this.$router.push("/recharge");
		},
		checkWalletStatus() {
			this.isCardBound = false;
			this.cardNumber = "";
			this.balance = 0.0;
			this.expiryDate = "";
			if (!this.userInfo || !this.userInfo.id) {
				return;
			}

			this.checkingWallet = true;
			this.$api
				.postData("/ecny/check_ecny_wallet_status", { user_id: this.userInfo.id })
				.then((res) => {
					if (res.code === 200) {
						if (res.data.is_bound) {
							this.isCardBound = true;
							// 后端已脱敏，前端直接使用
							this.cardNumber = res.data.card_number;
							this.balance = res.data.balance;
							// 格式化日期 格式为MM/DD 不要时分秒和年份
							this.expiryDate = res.data.created_at.split(" ")[0].split("-")[1] + "/" + res.data.created_at.split(" ")[0].split("-")[2];
						} else {
							this.isCardBound = false;
							console.log("钱包未绑定");
							this.cardNumber = "";
						}
					} else {
						console.error("检查钱包状态失败:", res.msg);
					}
				})
				.catch((error) => {
					console.error("检查钱包状态出错:", error);
				})
				.finally(() => {
					this.checkingWallet = false;
				});
		},
	},
};
</script>

<style scoped lang="scss">
.container {
	font-family: "D-DINExp";
	position: relative;
	overflow: hidden auto;
	height: calc(100vh - 68px - env(safe-area-inset-bottom));

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 275px;
		background: url("@/assets/top_bj.png") no-repeat center top;
		background-size: cover;
		z-index: 1;
	}
}

.header {
	position: relative;
	z-index: 10;

	.nav-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px;
		background: transparent;

		.nav-left {
			display: flex;
			align-items: center;
			gap: 8px;

			.logo {
				width: 136px;
				height: auto;
			}
		}
	}
}

.content {
	padding: 20px 16px calc(env(safe-area-inset-bottom) + 80px);
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	z-index: 10;

	.ecny-card {
		// padding: 24px 0;

		.card-content {
			.top-section {
				text-align: center;
				height: 276px;
				background: linear-gradient(0deg, #ffbab2 0%, #ffffff 100%);
				border-radius: 20px;
				padding: 24px;
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
				align-items: center;
				z-index: 12;
				position: relative;
				.sleeping-panda {
					position: relative;
					margin-bottom: 15px;
					.panda-image {
						width: 230px;
						height: 154px;
						object-fit: contain;
						margin: 0 auto;
						display: block;
					}
				}

				.message {
					font-size: 14px;
					line-height: 1.5;
					text-align: center;
				}
			}

			.wallet-info {
				background: linear-gradient(180deg, #ffd2cc 0%, #ffffff 90%);
				text-align: left;
				margin-bottom: 40px;
				padding: 30px 16px 16px;
				margin-top: -30px;
				z-index: 10;
				position: relative;
				h3 {
					font-size: 18px;
					font-weight: bold;
					margin-bottom: 15px;
				}

				p {
					color: #808080;
					font-size: 14px;
					line-height: 1.4;
					margin: 0;
				}
			}

			.button-section {
				.add-button {
					background: #eb2d16;
					color: white;
					border: none;
					border-radius: 25px;
					padding: 15px 40px;
					font-size: 16px;
					font-weight: bold;
					cursor: pointer;
					transition: background-color 0.3s;
					width: 100%;
					height: 50px;
					&:hover {
						background: #d4240f;
					}
				}
			}

			.ecny-card-display {
				background: url("@/assets/ecny/card_bg.png") no-repeat center center;
				background-size: 100% 100%;
				border-radius: 20px;
				height: 168px;
				padding: 16px 20px 16px 20px;
				position: relative;
				overflow: hidden;
				z-index: 12;

				.card-header {
					display: flex;
					justify-content: space-between;
					margin-bottom: 20px;

					.card-status {
						color: rgba(255, 255, 255, 0.7);
						font-size: 14px;
						font-weight: 400;
					}
					.card-status-icon {
						width: 115px;
					}
				}

				.card-body {
					display: flex;
					justify-content: space-between;
					align-items: flex-end;
					position: relative;
					z-index: 2;
					height: calc(100% - 50px);

					.balance-section {
						height: 100%;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						.balance {
							color: white;
							font-size: 32px;
							font-weight: bold;
							margin-bottom: 8px;
							font-family: "D-DINExp-Bold";
						}

						.card-number {
							color: rgba(255, 255, 255, 0.9);
							font-size: 14px;
							margin-bottom: 4px;
							letter-spacing: 1px;
						}

						.expiry-date {
							color: rgba(255, 255, 255, 0.8);
							font-size: 12px;
						}
					}

					.ecny-logo-section {
						text-align: right;

						.ecny-logo {
							width: 90px;
							object-fit: contain;
							margin: 0 auto;
							display: block;
						}
					}
				}
			}

			.action-buttons {
				display: flex;
				gap: 12px;
				margin-top: 20px;

				.action-btn {
					flex: 1;
					height: 48px;
					border: 0;
					border-radius: 12px;
					background: #f7f0f0;
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 8px;
					cursor: pointer;
					transition: all 0.3s;
					width: 173px;
					height: 75px;
					display: flex;
					flex-direction: column;
					color: #ea2e17;
					font-size: 15px;
					&:hover {
						border-color: #ff6b6b;
						background: #fff5f5;
					}
					img {
						width: 24px;
						height: 24px;
						margin-right: 8px;
					}
					.van-button__text {
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}
			}
		}
	}
}
.ecny-modal {
	background: none;
}

// 弹窗样式
.modal-content {
	width: calc(var(--maxWidth) - 40px);
	height: calc(var(--maxWidth) - 40px);
	background: url("@/assets/ecny/tcbj.png") no-repeat center center;
	background-size: contain;
	border-radius: 20px;
	overflow: hidden;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
}

.modal-header {
	padding: 12px 40px 20px;
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;

	.modal-title {
		font-size: 24px;
		font-weight: bold;
		color: #000;
		margin: 0;
		font-family: "D-DINExp-Bold";
	}
}

.modal-body {
	padding: 30px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	.input-group {
		margin-bottom: 45px;
		width: 100%;
		position: relative;
		min-height: 60px;

		.card-input {
			width: 100%;
			padding: 15px 20px;
			border: none;
			border-radius: 12px;
			font-size: 16px;
			color: #333;
			box-sizing: border-box;
			transition: all 0.3s ease;
			background: #f7f0f0;
			&::placeholder {
				color: #999;
				font-size: 14px;
			}

			&:focus {
				outline: none;
			}
		}

		.error-message {
			color: #ff5252;
			font-size: 12px;
			position: absolute;
			top: 100%;
			left: 0;
			text-align: left;
			padding-left: 4px;
			animation: fadeIn 0.3s ease;
			height: 16px;
			line-height: 16px;
		}
	}

	.confirm-btn {
		width: 80%;
		padding: 15px;
		background: #ff8c7f;
		color: white;
		border: none;
		border-radius: 25px;
		font-size: 16px;
		font-weight: bold;
		cursor: pointer;
		transition: all 0.3s ease;
		font-family: "D-DINExp-Bold";
		opacity: 0.6;
		cursor: not-allowed;

		&.active {
			opacity: 1;
			cursor: pointer;
			background: #eb2d16;

			&:hover {
				background: #ff5252;
				transform: translateY(-2px);
				box-shadow: 0 5px 15px rgba(255, 107, 107, 0.3);
			}

			&:active {
				transform: translateY(0);
			}
		}
	}
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-5px);
	}
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(-5px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

// Loading样式
.loading-content {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 300px;
	margin-top: 100px;
}

.loading-section {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
}

.loading-text {
	color: #666;
	font-size: 14px;
	font-weight: 500;
}
// 确保弹窗样式正确
:deep(.ecny-modal) {
	z-index: 9999 !important;
}

:deep(.van-overlay) {
	z-index: 9998 !important;
}
.ecny_info {
	border-radius: 20px 20px 0 0;
	width: 100%;
	object-fit: contain;
}
</style>
